"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageSize = exports.schema = void 0;
var yup_1 = require("yup");
exports.schema = (0, yup_1.object)({
    fuzzyIdAndNameSearchQuery: (0, yup_1.string)(),
    endpointSearchQuery: (0, yup_1.string)(),
    startDate: (0, yup_1.number)(),
    endDate: (0, yup_1.number)(),
    payrollProviderId: (0, yup_1.string)(),
    statusCode: (0, yup_1.number)(),
    statusDescription: (0, yup_1.string)(),
    pageIndex: (0, yup_1.number)().default(0),
});
var Method = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};
exports.pageSize = 20;
